import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthStateService {
  private readonly AUTH_TOKEN_KEY = 'hns_auth_token';
  private readonly AUTH_REP_NAME_KEY = 'hns_rep_name';
  private readonly MEMBER_DOB_KEY = 'hns_member_dob';
  private readonly tokenSubject = new BehaviorSubject<string>(this.loadToken());
  private readonly isAuthenticatedSubject = new BehaviorSubject<boolean>(Boolean(this.loadToken()));

  token$ = this.tokenSubject.asObservable();
  isAuthenticated$ = this.isAuthenticatedSubject.asObservable();

  private loadToken(): string {
    return sessionStorage.getItem(this.AUTH_TOKEN_KEY) ?? '';
  }

  private loadRepName(): string {
    return sessionStorage.getItem(this.AUTH_REP_NAME_KEY) ?? '';
  }

  setToken(token: string, repName = ''): void {
    if (token) {
      sessionStorage.setItem(this.AUTH_TOKEN_KEY, token);
      const normalizedRepName = repName.trim();
      if (normalizedRepName) {
        sessionStorage.setItem(this.AUTH_REP_NAME_KEY, normalizedRepName);
      } else {
        sessionStorage.removeItem(this.AUTH_REP_NAME_KEY);
      }
    } else {
      sessionStorage.removeItem(this.AUTH_TOKEN_KEY);
      sessionStorage.removeItem(this.AUTH_REP_NAME_KEY);
    }

    this.tokenSubject.next(token);
    this.isAuthenticatedSubject.next(Boolean(token));
  }

  getToken(): string {
    return this.tokenSubject.getValue();
  }

  hasStoredRepName(): boolean {
    return Boolean(this.loadRepName().trim());
  }

  /** Stores the member's date of birth (ISO yyyy-MM-dd) for later age-based gating. */
  setMemberDob(dob: string): void {
    if (dob) {
      sessionStorage.setItem(this.MEMBER_DOB_KEY, dob);
    } else {
      sessionStorage.removeItem(this.MEMBER_DOB_KEY);
    }
  }

  getMemberDob(): string {
    return sessionStorage.getItem(this.MEMBER_DOB_KEY) ?? '';
  }

  get isAuthenticated(): boolean {
    return this.isAuthenticatedSubject.getValue();
  }
}
